import script from "./productivity-report.vue?vue&type=script&setup=true&lang=js"
export * from "./productivity-report.vue?vue&type=script&setup=true&lang=js"

import "./productivity-report.vue?vue&type=style&index=0&id=0f7f9d0c&scoped=true&lang=css"

import exportComponent from "/home/staging-tcms.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f7f9d0c"]])

export default __exports__